import { httpInterceptor } from '../http-interceptor';

export class FeatureFlagService {
  static ENDPOINTS = {
    GET_ALL: 'FeatureFlag/getall',
    GET_BY_NAME: 'FeatureFlag/getbyname',
    IS_ENABLED: 'FeatureFlag/isenabled',
    CREATE: 'FeatureFlag/create',
    UPDATE: 'FeatureFlag/update',
    DELETE: 'FeatureFlag/delete',
  };

  static async getAllFeatureFlags() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async getFeatureFlagByName(name) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_NAME}/${name}`);
  }

  static async isFeatureEnabled(name) {
    return httpInterceptor.get(`${this.ENDPOINTS.IS_ENABLED}/${name}`);
  }

  static async createFeatureFlag(data) {
    return httpInterceptor.post(this.ENDPOINTS.CREATE, data);
  }

  static async updateFeatureFlag(data) {
    return httpInterceptor.put(this.ENDPOINTS.UPDATE, data);
  }

  static async deleteFeatureFlag(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE}/${id}`);
  }
} 